import axios from 'axios';
import { Event } from 'main/store/schedule/state';
import { API_URL, createHeaders } from '.';

export const getEvents = async () => {
    const response = await axios.get<Event[]>(`${API_URL}/events`);
    return response.data;
}

export const addEvent = async (event: Event, token: string) => {
    const response = await axios.post<{ id: string }>(`${API_URL}/events`, event, createHeaders(token));
    return {
        ...event,
        id: response.data.id
    }
}

export const updateEvent = async (event: Event, token: string) => {
    await axios.put(`${API_URL}/events/${event.id}`, event, createHeaders(token));
}

export const deleteEvent = async (eventId: string, token: string) => {
    await axios.delete(`${API_URL}/events/${eventId}`, createHeaders(token));
}
